var User = /** @class */ (function () {
    function User(_a) {
        var _this = this;
        var id = _a.id, username = _a.username, email = _a.email, profileImageUrl = _a.profileImageUrl;
        this.toJSON = function () { return ({
            id: _this.id,
            username: _this.username,
            email: _this.email,
            profileImageUrl: _this.profileImageUrl,
        }); };
        this.id = id;
        this.username = username;
        this.email = email;
        this.profileImageUrl = profileImageUrl;
    }
    User.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, username = _a.username, email = _a.email, profileImageUrl = _a.profileImageUrl;
        if (typeof id !== 'string')
            throw new Error('.id must be a string');
        if (username !== undefined && typeof username !== 'string')
            throw new Error('.username must be a string');
        if (email !== undefined && typeof email !== 'string')
            throw new Error('.email must be a string');
        if (profileImageUrl !== undefined && typeof profileImageUrl !== 'string')
            throw new Error('.profileImageUrl must be a string');
        return new User({
            id: id,
            username: username,
            email: email,
            profileImageUrl: profileImageUrl,
        });
    };
    return User;
}());
export default User;
